import { heroStats } from '@/mocks/homeData';

export default function Hero() {
  const jump = (id: string) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.offsetTop - 72, behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative w-full h-[640px] md:h-[760px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dramatic%20abstract%20editorial%20collage%20of%20shredded%20newsprint%20fragments%2C%20glowing%20amber%20light%20beams%20and%20deep%20crimson%20ink%20splashes%20floating%20over%20a%20dark%20warm%20paper%20texture%2C%20stylized%20flat%20poster%20art%2C%20high%20contrast%2C%20cinematic%20mood%2C%20empty%20negative%20space%20in%20the%20center%2C%20no%20text&width=1920&height=1080&seq=bkd-hero-01&orientation=landscape"
        alt="爆料看点首屏视觉：碎纸爆料线索与光束交织的抽象拼贴"
        title="爆料看点 · 系列爆料追踪与横向比较分析"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/65 to-foreground-950/85"></div>

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-4 md:px-8">
          <div className="max-w-4xl">
            <div className="flex flex-wrap items-center gap-2 mb-6">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                <i className="ri-flashlight-fill"></i>
                系列爆料追踪
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs font-medium backdrop-blur-sm whitespace-nowrap">
                同类事件对比
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs font-medium backdrop-blur-sm whitespace-nowrap">
                相似案例合集
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
              一条线索，
              <span className="text-accent-400">横向吃透到底</span>
            </h1>

            <p className="text-base md:text-lg text-background-100/90 leading-relaxed max-w-2xl mb-8">
              我们不只播报单条消息。顺着同一条线索，把系列爆料、同类事件和相似案例放在同一页横向比较——
              触发原因、发酵周期、回应方式、结果走向，一次看清共性与差异。
            </p>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mb-12">
              <button
                type="button"
                onClick={() => jump('tracking')}
                className="px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                开始追踪线索
              </button>
              <button
                type="button"
                onClick={() => jump('compare')}
                className="px-6 py-3 rounded-md bg-background-50/10 text-background-50 font-medium border border-background-50/30 hover:bg-background-50/20 backdrop-blur-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                进入横向对比
              </button>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-3xl">
              {heroStats.map((stat) => (
                <div key={stat.label} className="border-l-2 border-accent-500/70 pl-3 md:pl-4">
                  <div className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-background-100/70 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}